import { TransferMethod } from "../../core/models/entities/LogoOptions";

const SCREEN_PRINT = "screen print";

export const isScreenPrintMethod = (m: TransferMethod): boolean =>
  m.displayName.toLowerCase().includes(SCREEN_PRINT) ||
  m.type.toLowerCase().includes(SCREEN_PRINT);

/**
 * Filters methods users must not be able to PICK in the frontend:
 * - screen-print methods (hardcoded rule — only created via NAV import)
 * - methods on the admin-managed blocklist (Metoder page), matched
 *   case-insensitively on method key
 * Never removes the currently selected method, so an existing/cloned logo
 * whose method is later blocked keeps displaying it.
 */
export const excludeNonSelectableMethods = (
  methods: TransferMethod[],
  selectedKey?: string | null,
  blockedKeys?: readonly string[] | null
): TransferMethod[] => {
  const blocked = new Set((blockedKeys ?? []).map((k) => k.toLowerCase()));
  return methods.filter(
    (m) =>
      m.key === selectedKey ||
      (!isScreenPrintMethod(m) && !blocked.has(m.key.toLowerCase()))
  );
};

/** @deprecated use excludeNonSelectableMethods (also applies the admin blocklist) */
export const excludeScreenPrintMethods = (
  methods: TransferMethod[],
  selectedKey?: string | null
): TransferMethod[] => excludeNonSelectableMethods(methods, selectedKey);

type Translate = (key: string) => string;

/**
 * The method text under a logo's title (logo list, customer edit screen's
 * Logos section): "Screen print" / "Embroidery" translated, every other
 * method as "<type> <displayName>" in lower case. Optional chaining and the
 * Partial type: rows from foreign orgs (admin browsing / act-as) can arrive
 * without a transfer method - mapLogo turns a null DTO field into {} - and a
 * throw here would take a whole list to RouteErrorView. Pure: no React.
 */
export function transferMethodLabel(
  method: Partial<TransferMethod> | undefined | null,
  t: Translate
): string {
  const transferType = method?.type?.toLowerCase() ?? "";
  if (transferType === "direk tryk" || transferType === "screen print") {
    return t("logoList.screenPrint");
  }
  if (transferType === "broderi" || transferType === "embroidery") {
    return t("logoList.embroidery");
  }
  return `${transferType} ${method?.displayName?.toLowerCase() ?? ""}`.trim();
}
